import type * as SentryBrowser from '@sentry/browser';
import type * as SentryNode from '@sentry/node';

let Sentry: typeof SentryBrowser | typeof SentryNode;

            
                                 
         
Sentry = require('@sentry/browser');
          

export default Sentry;
